import { render, staticRenderFns } from "./num6.vue?vue&type=template&id=00e2c186&"
import script from "./num6.vue?vue&type=script&lang=js&"
export * from "./num6.vue?vue&type=script&lang=js&"
import style0 from "./num6.vue?vue&type=style&index=0&id=00e2c186&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports